import { ColorsEnum } from "../et3-theme/colors";

const ALPHA_COUNT_BACKGROUND = "14";

export const COLLAPSIBLE_CHEVRON_BOX = 24;
export const COLLAPSIBLE_CHEVRON_SIZE = 13;
export const COLLAPSIBLE_COUNT_HEIGHT = 22;
export const COLLAPSIBLE_COUNT_WIDTH = 46;
export const COLLAPSIBLE_COUNT_FONT_SIZE = 13;
export const COLLAPSIBLE_SUMMARY_FONT_SIZE = 14;

export const COLLAPSIBLE_ROTATION_TRANSITION_CSS = "transform 150ms ease";
export const COLLAPSIBLE_OPEN_ROTATION_CSS = "rotate(0deg)";
export const COLLAPSIBLE_CLOSED_ROTATION_CSS = "rotate(-90deg)";
export const COLLAPSIBLE_COUNT_RADIUS_CSS = "11px";
export const COLLAPSIBLE_COUNT_BACKGROUND = `${ColorsEnum.maastrichtBlue}${ALPHA_COUNT_BACKGROUND}`;
